import React from "react";
import { Link } from "react-router-dom";
import { Mail, MapPin, ArrowUpRight } from "lucide-react";

const LOGO_COLOR =
  "https://customer-assets.emergentagent.com/job_dd9fcd17-40f1-4372-98d5-220ac01e3675/artifacts/wrf3l981_QC4Health%20Colour.png";

export default function Footer() {
  return (
    <footer className="bg-black text-white/80" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src={LOGO_COLOR}
              alt="QC4Health"
              className="h-14 w-auto mb-6"
              draggable={false}
            />
            <p className="text-white/70 max-w-md leading-relaxed">
              Clinical governance simplified. The integrated, AI-supported
              platform trusted by 100+ hospitals since 2015.
            </p>
            <div className="mt-8 flex flex-col gap-3 text-sm">
              <a
                href="mailto:info@tmrglobal.com"
                className="inline-flex items-center gap-2 text-white/75 hover:text-white transition-colors"
                data-testid="footer-email-link"
              >
                <Mail className="w-4 h-4" />
                info@tmrglobal.com
              </a>
              <span className="inline-flex items-center gap-2 text-white/60">
                <MapPin className="w-4 h-4" />
                TMR Global — Asia Pacific
              </span>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#3FB8E5] mb-5">
              Product
            </div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/product" className="hover:text-white transition-colors" data-testid="footer-link-product">Modules</Link></li>
              <li><Link to="/pricing" className="hover:text-white transition-colors" data-testid="footer-link-pricing">Pricing</Link></li>
              <li><Link to="/book-demo" className="hover:text-white transition-colors" data-testid="footer-link-book-demo">Book a Demo</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#3FB8E5] mb-5">
              Company
            </div>
            <ul className="space-y-3 text-sm">
              <li><Link to="/about" className="hover:text-white transition-colors" data-testid="footer-link-about">About</Link></li>
              <li><Link to="/resources" className="hover:text-white transition-colors" data-testid="footer-link-resources">Resources</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors" data-testid="footer-link-contact">Contact</Link></li>
              <li><Link to="/privacy" className="hover:text-white transition-colors" data-testid="footer-link-privacy">Privacy Policy</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="text-xs font-bold tracking-[0.2em] uppercase text-[#3FB8E5] mb-5">
              Standards
            </div>
            <ul className="space-y-3 text-sm text-white/70">
              <li>NSQHS</li>
              <li>Aged Care Quality Standards</li>
              <li>HDSS</li>
              <li>JCI</li>
              <li>CQC</li>
              <li>Accreditation Canada</li>
              <li>HAS</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-xs text-white/50">
            © 2026 TMR Global. All Rights Reserved.
          </div>
          <a
            href="https://tidycal.com/dbenson/60-minute-meeting"
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-1 text-xs text-white/60 hover:text-white transition-colors"
            data-testid="footer-tidycal-link"
          >
            Powered by TidyCal booking
            <ArrowUpRight className="w-3 h-3" />
          </a>
        </div>
      </div>
    </footer>
  );
}
